import { createContext, useCallback, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CoffeePortal from "../components/CoffeePortal";

const PortalContext = createContext(null);

export function PortalProvider({ children }) {
  const navigate = useNavigate();
  const portalRef = useRef(null);
  const busyRef = useRef(false);

  const go = useCallback(
    (to) => {
      // warm the lazy route chunk so the portal never reveals a blank page
      if (to.startsWith("/product/")) import("../pages/ProductDetail");
      else if (to === "/shop") import("../pages/Shop");
      else if (to === "/story") import("../pages/Story");
      else if (to === "/") import("../pages/Home");
      else if (to === "/checkout") import("../pages/Checkout");

      const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      // checkout is a purchase moment — never gate it behind the cinematic transition
      if (to === "/checkout" || reduced || !portalRef.current || busyRef.current) {
        navigate(to);
        return;
      }
      busyRef.current = true;
      portalRef.current.play(() => navigate(to), () => (busyRef.current = false));
    },
    [navigate]
  );

  return (
    <PortalContext.Provider value={{ go }}>
      {children}
      <CoffeePortal ref={portalRef} />
    </PortalContext.Provider>
  );
}

export function usePortal() {
  return useContext(PortalContext);
}
